import { apiGet, apiPost, demoMode } from './api';

// Доступ в кабинет владельца.
// Демо: код по умолчанию 00000000, разблокировка в sessionStorage —
// это режим показа, а не боевой вход.
// Прод: владелец входит почтой и паролем. Пароль проверяет Pages Function
// /api/owner/login (PBKDF2-SHA256), сессия лежит в httpOnly-cookie mnc_owner.
// На клиенте ни пароля, ни хеша, ни токена нет.
export const DEFAULT_OWNER_PIN = '00000000';

const UNLOCK_KEY = 'mnc-owner-unlocked';
const PIN_KEY = 'mnc-owner-pin';

// --- демо: код из env/дефолта, разблокировка на сессию вкладки ---
export function getOwnerPin(): string {
  if (!demoMode) return DEFAULT_OWNER_PIN;
  try {
    const stored = localStorage.getItem(PIN_KEY);
    if (stored && stored.trim()) return stored.trim();
  } catch {
    /* приватный режим */
  }
  const fromEnv = import.meta.env.VITE_OWNER_PIN;
  if (typeof fromEnv === 'string' && fromEnv.trim()) return fromEnv.trim();
  return DEFAULT_OWNER_PIN;
}

export function checkOwnerPin(input: string): boolean {
  return input.trim() === getOwnerPin();
}

// Смена кода — только демо. Пустая строка возвращает код по умолчанию.
export function setOwnerPin(next: string): void {
  if (!demoMode) return;
  try {
    const clean = next.trim();
    if (clean) localStorage.setItem(PIN_KEY, clean);
    else localStorage.removeItem(PIN_KEY);
  } catch {
    /* приватный режим */
  }
}

// --- прод: вход владельца через свой бэкенд ---
// Сессия — httpOnly-cookie, поэтому после входа достаточно перезапросить
// /api/owner/session, чтобы узнать состояние.
export async function ownerSignIn(email: string, password: string): Promise<void> {
  if (demoMode) return;
  await apiPost<{ ok: boolean }>('/owner/login', { email, password });
}

export async function ownerSignOut(): Promise<void> {
  if (demoMode) {
    lockOwner();
    return;
  }
  await apiPost<{ ok: boolean }>('/owner/logout', {});
}

export async function isOwnerAuthenticated(): Promise<boolean> {
  if (demoMode) return isOwnerUnlocked();
  try {
    const res = await apiGet<{ authenticated: boolean }>('/owner/session');
    return Boolean(res.authenticated);
  } catch {
    return false;
  }
}

// --- демо-разблокировка (только demoMode) ---
export function isOwnerUnlocked(): boolean {
  if (!demoMode) return false;
  try {
    return sessionStorage.getItem(UNLOCK_KEY) === '1';
  } catch {
    return false;
  }
}

export function unlockOwner(): void {
  if (!demoMode) return;
  try {
    sessionStorage.setItem(UNLOCK_KEY, '1');
  } catch {
    /* приватный режим */
  }
}

export function lockOwner(): void {
  if (!demoMode) return;
  try {
    sessionStorage.removeItem(UNLOCK_KEY);
  } catch {
    /* noop */
  }
}
